// extracted by mini-css-extract-plugin
export var brand = "_aq-9";
export var compact = "_aq-6";
export var extraSmall = "_aq-7";
export var icon = "_aq-0";
export var large = "_aq-4";
export var light = "_aq-1";
export var medium = "_aq-5";
export var outline = "_aq-b";
export var primaryDark = "_aq-a";
export var primaryLight = "_aq-8";
export var primaryModern = "_aq-c";
export var success = "_aq-2";
export var successSolid = "_aq-3";